<template>
  <div class="upload">
    <el-upload
      :action="action"
      :accept="accept"
      :headers="headers"
      :file-list="fileList"
      :data="qiniuData"
      :before-upload="beforeupload"
      :on-exceed="exceed"
      :on-remove="handleRemove"
      :on-error="uploadErr"
      :show-file-list="showFileList"
      multiple
      :limit="limit"
      :on-success="
        (response, file, fileList) => uploadSuccess(response, file, fileList)
      "
    >
      <el-button size="small" type="primary">{{$t('config.text5')}}</el-button>
      <div slot="tip" class="el-upload__tip" v-if="size">
        {{$t('config.text6') + accept + $t('config.text7') + size + "M" }}
      </div>
    </el-upload>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      qiniuData: {},
      domain: null,
      headers: {},
      action:''
    };
  },
  props: ["limit", "fileList", "type", "accept", "uploaDisabled", "size","showFileList"],
  mounted() {
    this.getQiniuToken();
    this.headers = { Authorization: localStorage.getItem("token") };
  },
  methods: {
    //获取七牛token
    getQiniuToken() {
      this.request.qiniuUploadToken().then((res) => {
        this.qiniuData.token = res.data.uptoken;
        this.domain = res.data.domain;
        this.action = res.data.upload
      });
    },
    //上传成功
    uploadSuccess(res, file, fileList) {
      this.$emit("success", {
        url: this.domain + res.key,
        hash: res.hash,
        name: res.key,
        size: file.size,
        fileList,
      });
    },
    uploadErr(e){
      console.log(e);
      this.$message.error(that.$t('config.text33'));
    },
    exceed() {
      this.$message.error(this.$t('config.text8'));
    },
    //删除文件
    handleRemove(file) {
      this.$emit("remove", file.name);
    },
    //  上传前处理文件类型和大小
    beforeupload(file) {
      let that = this;
      let str = '.' + file.name.split('.')[file.name.split('.').length-1]
      let isKon = file.name.indexOf(" ") != -1
      let t = new RegExp("[\\u4E00-\\u9FFF]+","g");;
      // console.log('.' + file.name.split('.')[file.name.split('.').length-1]);
      let arr = this.accept.split(',');
      // this.qiniuData.key = "" + new Date().getTime() + Math.round(Math.random() * 10000) + '.' + file.name.split('.')[file.name.split('.').length-1];
      this.qiniuData.key = file.name

       // 文件类型
      const isApk = arr.indexOf(str) != -1;
      const isSize = file.size / 1024 / 1024 < this.size;
      if (isKon) {
        this.$message.error(that.$t('config.text32'));
        return false;
      }
      if (t.test(file.name)) {
        this.$message.error("文件名不能有中文");
        return false;
      }
      if (!isApk) {
        this.$message.error(that.$t('config.text6') + this.accept + that.$t('config.text7')  + this.size + "M");
        return false;
      }
      if(this.size && !isSize){
        this.$message.error(that.$t('config.text6') + this.accept + that.$t('config.text7')  + this.size + "M");
        return false;
      }
      return isApk;
    },
  },
};
</script>
<style scoped>
</style>